import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { default as GetStartedList } from './GetStartedList';
import { GetStartedListPosition } from '../enums/GetStartedListPosition';
import { isGetStartedInQuickOptionVisible } from '../selectors/isGetStartedInQuickOptionVisible';

const styles = require('./GetStartedListInQuickOption');

const GetStartedListInQuickOption = observer(function GetStartedListInQuickOption(props: {}) {
    return (
        isGetStartedInQuickOptionVisible() && (
            <GetStartedList
                position={GetStartedListPosition.QuickOption}
                className={styles.paneWrapper}
            />
        )
    );
});

export default GetStartedListInQuickOption;
